import React from 'react';

import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';

import OasisNetworkNav from './OasisNetworkNav';
import ApiUtils from '../util/ApiUtils';
import SPUtilities from '../util/SPUtilities';
import UIUtils from '../util/UIUtils';
import SPCalc from '../util/SPCalc';
import Special from '../components/Special';


class NetworkStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coinStat: {},
      pool: {},
      isLoading: true
    }
  }

  async componentDidMount() {
    const coinStat = await ApiUtils.get("listData?type=coinStat");
    // console.log("coinStat is:", coinStat);

    this.setState({coinStat: coinStat, isLoading: false});
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading Network Stats</div>;
    }

    var bgColor = "dark";
    var fontColor = "white";

    return (
      <div>
        <Special />
        <p/>
        <h4 style={{align: "center"}}><span><strong>Oasis Network Stats</strong></span>
          <span className="buttonWithText">{UIUtils.renderReload(this)}</span></h4>

        <p>Last updated - {this.state.coinStat.lastUpdated} GMT</p>
        <CardDeck>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Total Staked</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.totalStake}</Card.Title>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Percent Staked</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.percentStaked}%</Card.Title>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Annual Reward Rate (%)</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.currentRewardRate} (*may not be accurate)</Card.Title>
            </Card.Body>
          </Card>
        </CardDeck>
        <p/>

        <CardDeck>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header># of Staking Pools</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.stakingPools}</Card.Title>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Unique Delegates</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.uniqueDelegates}</Card.Title>
            </Card.Body>
          </Card>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Active Accounts</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.activeAccounts}</Card.Title>
            </Card.Body>
          </Card>
        </CardDeck>
        <p/>

        <CardDeck>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Epoch</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.currentEpoch}</Card.Title>
            </Card.Body>
          </Card>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Total Supply</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.totalSupply}</Card.Title>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Common Supply</Card.Header>
            <Card.Body>
              <Card.Title>{this.state.coinStat.stakeSupply}</Card.Title>
            </Card.Body>
          </Card>
        </CardDeck>

        <p/>
        <OasisNetworkNav />
      </div>
    );
  }
}

export default NetworkStats;



// WEBPACK FOOTER //
// ./src/network/NetworkStats.js